import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const rewardMgtService = {
  //GET
  getAllCoupons: () =>
    serviceInstance
      .get(`${config.baseurl}/api/Coupons`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  
  getAllCustomers: () =>
    serviceInstance
      .get(`${config.baseurl}/Account/GetAllCustomers`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  getAllCashbacks: () =>
    serviceInstance
      .get(`${config.baseurl}/api/Cashback`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  // Get coupon by ID with beneficiaries
  getCouponById: (couponId) =>
    serviceInstance
      .get(`${config.baseurl}/api/Coupons/${couponId}`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  getCashbackById: (cashbackId) =>
    serviceInstance
      .get(`${config.baseurl}/api/Cashback/${cashbackId}`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  //POST
  createCoupon: (data) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons`, data)
      .then(({ data, status }) => ({
        ...data,
        status,
    })),

  createCashback: (data) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback`, data)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  // Send reminder methods
  sendCouponReminder: (couponId, userId) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons/${couponId}/send-reminder`, { userId })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  sendCashbackReminder: (cashbackId, userId) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback/${cashbackId}/send-reminder`, { userId })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  //PUT/UPDATE
  updateCoupon: (id, data) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons/update/${id}`, data)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
      
  updateCashback: (id, data) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback/update`, { id, ...data })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  
  // Apply to customers (existing method)
  applyCouponToCustomers: (id, customerIds) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons/${id}/assign`, customerIds)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  
  removeBeneficiariesFromCoupon: (couponId, customerIds) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons/${couponId}/remove`, customerIds)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  applyCashbackToCustomers: (cashbackId, customerIds) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback/${cashbackId}/assign`, customerIds)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  removeBeneficiariesFromCashback: (cashbackId, customerIds) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback/${cashbackId}/remove`, customerIds)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  // DELETE Methods

  deleteCoupon: (couponId) =>
    serviceInstance
      .post(`${config.baseurl}/api/Coupons/delete/${couponId}`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  deleteCashback: (cashbackId) =>
    serviceInstance
      .post(`${config.baseurl}/api/Cashback/delete/${cashbackId}`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  

  // Optional utility methods
  getProgramStatistics: (programId, programType = 'coupon') =>
    serviceInstance
      .get(`${config.baseurl}/api/${programType === 'coupon' ? 'Coupons' : 'Cashback'}/${programId}/statistics`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  exportBeneficiaries: (programId, programType = 'coupon') =>
    serviceInstance
      .get(`${config.baseurl}/api/${programType === 'coupon' ? 'Coupons' : 'Cashback'}/${programId}/export-beneficiaries`, {
        responseType: 'blob'
      })
      .then(({ data, status }) => ({
        data,
        status,
      })),
};

export default rewardMgtService;